












































































import {Component, Vue} from 'vue-property-decorator'
import {errorLogModule} from '@/store/module/ErrorLog'

@Component({
    name: 'ErrorLog'
})
export default class extends Vue {
    private dialogTableVisible = false

    get errorLogs() {
        return errorLogModule.logs
    }

    private clearAll() {
        this.dialogTableVisible = false
        errorLogModule.clearErrorLog()
    }
}
